/**
 * The client app's empty state (the Bookings page's, mockup Frame 4): a gold
 * calendar orb, a title and one line saying what will show up there. Shared by
 * Bookings and the Book screen's empty tabs (Gabriel 2026-10-21).
 */
import styles from './EmptyBlock.module.css';

function CalendarOrbIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="3" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

export function EmptyBlock({ title, sub, testId }: { title: string; sub: string; testId?: string }) {
  return (
    <div className={styles.emptyBlock} data-testid={testId}>
      <div className={styles.emptyOrb}>
        <CalendarOrbIcon />
      </div>
      <h2 className={styles.emptyTitle}>{title}</h2>
      <p className={styles.emptySub}>{sub}</p>
    </div>
  );
}
